import '@/styles/main.css';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from '@/App.vue';
import router from '@/core/router';
import { registerAuthGuard } from '@/core/router/guard';
import { registerModules } from '@/core/register-modules';

import { AnalyzerModule } from '@/modules/analyzer';
import { AuthModule } from '@/modules/auth';
import { UsersModule } from '@/modules/users';
import { useAuditsStore } from '@/stores/audits';

registerModules({
  AnalyzerModule,
  AuthModule,
  UsersModule,
});

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
app.use(router);

// Gate every route behind a live session (probes `me` on first navigation).
registerAuthGuard(router);

// Bootstrap the signed-in user's audits before the first paint. The guard's
// `me` probe has resolved by the time the router is ready, so init() knows
// whether there's a session (it no-ops for a guest — login re-runs it).
router.isReady().then(async () => {
  await useAuditsStore().init();
  app.mount('#app');
});
